import React, { useEffect, useRef, useState } from 'react'
import {
    View,
    Text,
    ScrollView,
    Dimensions,
    FlatList,
    TouchableOpacity,
    ImageBackground,
    Image,
    ActivityIndicator,
    TextInput,
    Button,
    Linking,
    Alert,
} from 'react-native'
import * as Location from 'expo-location'
import { StoresListModel, CampaignModel, CampaignScheduleModel, CampaignStepsModel, ActivitysModel } from './models/ScheduleModel'
import { Feather } from '@expo/vector-icons'
import theme from '../../../theme'
import styles from './ScheduleDistributorStyles'
import { CampaignViewDistributor, CustomBar } from './CampaignViewDistributor'
import { StoresFilterView } from './StoresFilterView'
import { StoreItem } from './StoreItem'
import { CampaignStatus, getStatusMap } from './StatusTagsStores'
import { TagsModel } from '../customUtils/Components/Models/TagsModel'
import { useSchedule } from './hooks/useSchedule'
import { format } from 'date-fns'
import { es, enUS } from 'date-fns/locale'
import { schedulesServices } from '../../../database/schedules.database'
import { distanceInMeters } from '../customUtils/calculateDistance'
import { FlashList } from '@shopify/flash-list'
import { Loader } from '../customUtils/Components/Loader'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { FormContentsModel, FormsModel, StepsModel } from './models/StoreDetailModel'
import { Calendar } from 'react-native-calendars'
import { useStoreContext } from './context/store.context'
import { getLocation } from '../appBar/context/LocationContext'
import { PostsServices } from '../../../database/posts.database'
import { CONSTANTS_TYPES_STEPS, FORM_SCHEDULE_STATUS } from './constants/constants.stores'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { SearchStores } from './components/SearchStores'
import expo from '../../../app.config'
import { useNavigation, useFocusEffect } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { BottomSheetAlertWithInput } from '../modals/BottomSheetAlert'
import { Ionicons } from '@expo/vector-icons'
import { SelectList } from 'react-native-dropdown-select-list'
import { LinealTabs } from '../customUtils/LinealTabs'
import { ActivityInput, InputCommentActivity, InputCommentSheet } from './FormItems/InputCommentItem'
import CustomAlert from '../customUtils/Components/CustomAlert'
import { getConection } from '../appBar/context/HeaderContext'
import { fetchAuthSession } from 'aws-amplify/auth'
import { request_checkin, request_save_schedules_activities } from '../../services/schedule.services'
import { FinishSheet, FormView } from './ExecutionView'
import { Content } from '../../services/interfaces/schedule.interface'
import { formatearFechaArgentina } from '../customUtils/AppConstants'
import { useNavigateTabsStore } from '../../redux/zustand/navigateTabsStore'
import { parseDateCardHistory } from '../../utils/formatDate.function'
import { UserServices } from '../../../database/user.database'
import { SCHEDULES_STORE_NAMES } from '../../db/posSchedules'
import { RefreshControl } from 'react-native-gesture-handler'
import { tagsDisData, useTabStore } from '../../redux/zustand/tabsStore'
import { usePermissionStore } from '../../redux/zustand/permissions-store'
import { PermissionsAdapter } from '../../utils/permission'
const { width } = Dimensions.get('window')
const { height } = Dimensions.get('screen')
import * as ImagePicker from 'expo-image-picker'
import Constants from 'expo-constants'
import { LinearGradient } from 'expo-linear-gradient'
import { validateConnectionNetwork } from '../../utils/functions.utils'
export const ScheduleDistributor = () => {
    const { languageFile } = getLanguage()
    const permission = usePermissionStore()
    const {
        campaign,
        goToForm,
        goToStore,
        loading,
        setLoading,
        generator,
        checkIn,
        checkout,
        historyForms,
        refreshForm,
        fetchData,
        messageService,
        reloadCounterFn,
        fetchDataGetHistoryForms,
        showMapButton,
        loadingSchedule,
    } = useSchedule() // descomentar esta linea y comentar toda la logica que hay abajo
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()
    const [refreshing, setRefreshing] = useState(false)
    const { userLat, userLng } = getLocation()
    const { isConnected, hasInternet } = getConection()
    const expoConfig = Constants.expoConfig || { name: '' }

    useFocusEffect(
        React.useCallback(() => {
            const CameraPermissions = async () => {
                let cameraPermissionResult = await ImagePicker.requestCameraPermissionsAsync()
                let mediaLibraryPermissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync()
                if (cameraPermissionResult.granted === false || mediaLibraryPermissionResult.granted === false) {
                    Alert.alert(
                        expoConfig.name + ' quiere acceder a tu camara y galería',
                        expoConfig.name +
                            ' necesita acceso a tu camara y galería para que puedas elegir una foto de perfil o subir imágenes en los relevamientos de las tiendas asignadas.',
                        [
                            {
                                text: 'Cancelar',
                                onPress: async () => {},
                            },
                            {
                                text: 'Configuración',
                                onPress: async () => {
                                    Linking.openSettings()
                                },
                            },
                        ],
                        { cancelable: true },
                    )
                }
            }

            const requestPermissions = async () => {
                // const servicesEnabled = await Location.hasServicesEnabledAsync()
                const servicesEnabled = await PermissionsAdapter.hasServicesEnabledAsync()
                console.log('63 -- 🚀 ~ requestPermissions ~ servicesEnabled:', servicesEnabled)
                permission.setLocationEnabled(servicesEnabled)
                let l = await permission.checkPermissions()
                if (!servicesEnabled) {
                    return
                }

                if (!permission.hasLocationPermission) {
                    setLoading(true)
                    // si no tengo, false, pido permisos
                    let { status } = await Location.getForegroundPermissionsAsync()
                    if (status === 'granted') {
                        // reloadCounterFn()
                        // fetchDataGetHistoryForms()
                        // fetchData()
                    } else {
                        setLoading(false)
                    }
                } else {
                    reloadCounterFn()
                    fetchDataGetHistoryForms()
                    fetchData()
                }
            }

            requestPermissions()
            CameraPermissions()
        }, [permission.hasLocationPermission]),
    )

    const onRefresh = async (clear = false) => {
        try {
            setRefreshing(true)
            if (clear) {
                console.log('elimino datos de agendaa')
                await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.SCHEDULES_VERSION, null)
                await schedulesServices.deleteAllTablesSchedule()
            }
            fetchData()

            setRefreshing(false)
        } catch (error) {
            console.error(error)
        }
    }

    if (!loading && !permission.hasLocationPermission) {
        return (
            <View style={styles.containerNoProducts}>
                <Image style={styles.image} source={require('../../../assets/noConnection.png')} />
                <Text style={styles.title}>Tienes los permisos de ubicación desactivados</Text>
                <Text style={styles.description}>Para habilitar esta sección, debés activar los permisos de ubicación de la App.</Text>
                <TouchableOpacity style={[styles.mainButtonRetry, { marginTop: 12 }]} onPress={() => Linking.openSettings()}>
                    <Text style={styles.mainButtonTextRetry}>Activar</Text>
                </TouchableOpacity>
            </View>
        )
    }
    if (!loading && !permission.locationEnabled) {
        return (
            <View style={styles.containerNoProducts}>
                <Image style={styles.image} source={require('../../../assets/noConnection.png')} />
                <Text style={styles.title}>Activa la ubicación</Text>
                <Text style={styles.description}>Para habilitar esta sección, debés activar la ubicación del dispositivo</Text>
            </View>
        )
    }
    if (!loading && (userLat == null || userLat == 0) && (userLng == null || userLng == 0)) {
        return (
            <View style={styles.containerNoProducts}>
                <Image
                    source={require('../../../assets/circleLoader.gif')} // Usa la importación del GIF
                    style={{ width: width / 6, height: width / 6 }} // Ajusta el tamaño según necesites
                    resizeMode='contain' // O "cover", dependiendo de cómo quieras que se ajuste
                />
                <Text style={styles.title}>Recuperando tu ubicación</Text>
                <Text style={styles.description}>Espera un momento</Text>
            </View>
        )
    }

    return loading ? (
        <Loader />
    ) : (
        <View style={styles.container}>
            {campaign && campaign.length > 0 ? (
                <FlatList
                    refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} progressViewOffset={10} />}
                    data={campaign}
                    horizontal={false}
                    showsVerticalScrollIndicator={false}
                    renderItem={({ item: campaign }) => (
                        <CampaignList
                            campaign={campaign}
                            onClickGoForm={goToForm}
                            onClickGoStore={goToStore}
                            generator={generator}
                            checkIn={checkIn}
                            checkOut={checkout}
                            historyForms={historyForms}
                            refreshForm={refreshForm}
                            onRefresh={onRefresh}
                            showMapButton={showMapButton}
                            loadingSchedule={loadingSchedule}
                        />
                    )}
                    numColumns={1}
                />
            ) : (
                <>
                    {/*<View style={styles.containerNoProducts}>
                        <Image style={styles.image} source={require('../../../assets/noAgendaWeek.png')} />
                        <Text style={styles.title}>{languageFile.no_agenda_week}</Text>
                        <Text style={styles.description}>{languageFile.no_information_week}</Text>
                        {generator && generator.active && !generator.is_moderator && (
                            <TouchableOpacity style={styles.formButton} onPress={() => goToCreateSchedule()}>
                                <Text style={styles.mainButtonText}>{generator.title ?? ''}</Text>
                            </TouchableOpacity>
                        )}
                    </View>*/}
                    <View style={styles.containerNoProductsBis}>
                        <Image style={styles.image} source={require('../../../assets/noAgendaToday.png')} />
                        <Text style={styles.title}>{languageFile.no_agenda_week}</Text>
                        <Text style={styles.description}>{languageFile.consult_your_supervisor}</Text>
                        <TouchableOpacity style={styles.mainButtonRetry} onPress={() => onRefresh(true)}>
                            <Text style={styles.mainButtonTextRetry}>{languageFile.retry}</Text>
                        </TouchableOpacity>
                    </View>
                </>
            )}
        </View>
    )
}

export const CampaignList = ({
    campaign,
    onClickGoForm,
    onClickGoStore,
    generator,
    checkIn,
    checkOut,
    historyForms,
    refreshForm,
    onRefresh,
    showMapButton,
    loadingSchedule,
}) => {
    const { stores, setStores } = useStoreContext()
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const [form, setForm] = useState(null)
    const mainViewRef = useRef(null)
    const [selectedSchedule, setSelectedSchedule] = useState(null)
    const [selectedScheduleTags, setSelectedScheduleTags] = useState([])
    const [page, setPage] = useState(0)
    const [size] = useState(10)
    const [tagID, setTagID] = useState(-1)
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()
    const { userLat, userLng, setUserLat, setUserLng, checkLocation, askAgain } = getLocation()
    const [userLocation, setUserLocation] = useState({ lat: userLat, lng: userLng })
    const [initialLocation, setInitialLocation] = useState({ lat: userLat, lng: userLng })
    const [loading, setLoading] = useState(true)
    const { languageFile } = getLanguage()
    const statusMap = getStatusMap(languageFile)
    const [dateSelected, setDateSelected] = useState({ date_init: null, date_finish: null })
    const [showCalendar, setShowCalendar] = useState(false)
    const [showAlert, setShowAlert] = useState(false)
    const [showNoStores, setShowNoStores] = useState(false)
    const [firstLoad, setFirstLoad] = useState(true)
    const [buttonDistributor, setButtonDistributor] = useState(null)
    const [listActivities, setListActivities] = useState([])
    const [listOthesActivities, setListOthesActivities] = useState([])
    const [report, setReport] = useState<null | { _id?: string; activity?: string; status?: number }>({})
    const { isConnected, hasInternet } = getConection()
    let fecha_hoy = new Date()
    let offset = fecha_hoy.getTimezoneOffset()
    // Convertir la fecha y hora actual de UTC a la zona horaria local del usuario
    fecha_hoy.setMinutes(fecha_hoy.getMinutes() - offset)
    const [dateTodayLocal, setDayTodayLocal] = useState(fecha_hoy)
    const [checkinData, setCheckinData] = useState([])
    //console.log('🚀 ~ CampaignList ~ checkinData:', checkinData)
    const [formsMB, setFormsMB] = useState([])
    const [formIncidence, setFormIncidence] = useState<FormsModel>(null)

    const setvacations = () => {
        let vacations = {}
        campaign.schedules.forEach((schedule) => {
            if (schedule.vacation) {
                let date = new Date(schedule.date_init)
                const year = date.getUTCFullYear()
                const month = String(date.getUTCMonth() + 1).padStart(2, '0') // Los meses son indexados desde 0
                const day = String(date.getUTCDate()).padStart(2, '0')
                const formattedDate = `${year}-${month}-${day}`

                let vacationDay = { [formattedDate]: { selected: true, selectedColor: theme.colors.vacationDaySelectedColor } }

                vacations = { ...vacations, ...vacationDay }
            }
        })
        return vacations
    }
    let vacations = setvacations()
    const [markedDates, setMarkedDates] = useState(vacations)

    const handleSelectLabel = (labelId) => {
        if (labelId !== tagID) {
            setTagID(labelId)
            setStores([])
            setPage(0)
            let newTags = selectedSchedule.tags.map((tag) => {
                if (tag._id === String(labelId)) {
                    return { ...tag, isSelected: true }
                } else {
                    return { ...tag, isSelected: false }
                }
            })
            setSelectedSchedule((prevSchedule) => ({
                ...prevSchedule,
                tags: newTags,
            }))
        }
        mainViewRef.current?.scrollToOffset({ offset: 0, animated: true })
    }

    const getStores = async (counter_stores = 1) => {
        // console.log('estoy en get_store', counter_stores)

        // setLoading(true)
        try {
            await checkForms(selectedSchedule, dateSelected.date_init)
            if (selectedSchedule) {
                const radius = 5000 // Radio de búsqueda en metros (5 km)
                await schedulesServices
                    .getStoresFromSchedule(
                        page,
                        size,
                        selectedSchedule._id,
                        tagID,
                        initialLocation.lat,
                        initialLocation.lng,
                        radius,
                        campaign.schedule_free,
                        dateSelected?.date_init,
                    )
                    .then((newStores) => {
                        newStores.forEach((store) => {
                            store.distance = distanceInMeters(userLocation.lat, userLocation.lng, store.lat, store.lng)
                        })

                        if (page > 0) {
                            setStores((prevStores) => {
                                const combinedStores = [...prevStores, ...newStores]
                                return combinedStores
                            })
                            //setLoading(false)
                        } else {
                            if (newStores && newStores.length > 0) {
                                setStores(newStores)

                                if (newStores.length == 0) {
                                    if (counter_stores != null && counter_stores < 3) {
                                        getStores(counter_stores + 1)
                                    } else {
                                        setShowNoStores(true)
                                        // setLoading(false)
                                    }
                                } else {
                                    setShowNoStores(false)
                                    //setLoading(false)
                                }
                            }
                        }
                    })
            }
        } catch (error) {
            console.error(error)
            setLoading(false)
        }
    }

    const handleEndReachedStores = () => {
        if (selectedSchedule) {
            if (stores.length >= size) {
                setPage((prevPage) => prevPage + 1)
            }
        }
    }
    const updateScheduleTags = async (todaySchedule) => {
        try {
            const newTags = []
            if (todaySchedule && todaySchedule?._id) {
                await schedulesServices.getProgressStatus(todaySchedule?._id, statusMap).then((campaignStatus) => {
                    campaignStatus.forEach((status) => {
                        let newTag = createTag(status?._id, languageFile)
                        if (newTag) {
                            if (!newTags.some((tag) => tag._id === newTag._id)) {
                                newTags.push(newTag)
                            }
                        }
                    })
                    if (newTags.length > 0) {
                        let todos = { title: languageFile.all, image: '', _id: '-1', isSelected: true }
                        newTags.unshift(todos)
                        setSelectedSchedule((prevSchedule) => ({
                            ...prevSchedule,
                            tags: newTags,
                        }))
                    }
                    if (firstLoad) {
                        setSelectedSchedule((prevSchedule) => ({
                            ...prevSchedule,
                            tags: newTags,
                        }))
                    } else {
                        const updatedTags = newTags.filter((tag) => !selectedSchedule?.tags.some((t) => t._id === tag._id))
                        const mergedTags = [...selectedSchedule.tags, ...updatedTags]

                        setSelectedSchedule((prevSchedule) => ({
                            ...prevSchedule,
                            tags: mergedTags,
                        }))
                    }

                    setFirstLoad(false)
                })
            }
        } catch (error) {
            console.error(error)
        }
    }

    const filterDay = (date) => {
        try {
            //Para cambiar a sábado
            const today = new Date(date) //new Date(date.getFullYear(), date.getMonth(), date.getDate())
            // const today = new Date('2024-10-12T12:56:46.950Z') //new Date(date.getFullYear(), date.getMonth(), date.getDate())

            if (campaign?.schedules) {
                //console.log(campaign?.schedules)
                // Encontrar el horario de hoy en las campañas
                const todaySchedule = campaign.schedules.find((schedule) => {
                    // Convertir las fechas de inicio y fin del horario a fecha local
                    const scheduleDateInit = new Date(schedule.date_init)
                    const scheduleDateFinish = new Date(schedule.date_finish)

                    // Verificar si la fecha de hoy está dentro del rango del horario
                    return scheduleDateInit <= today && scheduleDateFinish >= today
                })
                // si tengo algun checkout de esa agenda
                // si tengo es porque deberia ver el boton cerrar dia, entonces cambio status del distribuidor
                //console.log(todaySchedule)
                if (todaySchedule) {
                    if (todaySchedule.distributor) {
                        //aca seteo los estados de dsitributor setButtonDistributor

                        //si hay 1 checkin status :2
                        //si hay 1 checkou status :3
                        //si hay 2 checkins status:4
                        //si hay 2 checkout status:5
                        schedulesServices.get_advances_distributor(todaySchedule.distributor._id, todaySchedule._id).then((adv) => {
                            if (adv && adv.length > 0) {
                                if (adv.length > 1) {
                                    todaySchedule.distributor.status = adv[1]['status'] == 1 ? 5 : 4
                                } else {
                                    todaySchedule.distributor.status = adv[0]['status'] == 1 ? 3 : 2
                                }
                            }
                        })
                        // schedulesServices.get_checkin(todaySchedule.distributor._id, todaySchedule._id, true).then((get_checkin_local) => {
                        //     if (get_checkin_local && get_checkin_local.length > 0) {
                        //         todaySchedule.distributor.status = get_checkin_local.length > 1 ? 4 : 2 // status que presione al apretar 'checkin_distributor'
                        //     }
                        // })
                        // schedulesServices.get_checkout(todaySchedule.distributor._id, todaySchedule._id, true).then((get_checkout_local) => {
                        //     if (get_checkout_local && get_checkout_local.length > 0) {
                        //         todaySchedule.distributor.status = get_checkout_local.length > 1 ? 5 : 3
                        //     }
                        // })
                    }
                    if (todaySchedule.progress_diary) {
                        // Si hay diario de progreso, establecer inicio y fin del día actual
                        setDateSelected({
                            date_init: new Date(dateTodayLocal.setUTCHours(0, 0, 0, 0)).toISOString(),
                            date_finish: new Date(dateTodayLocal.setUTCHours(23, 59, 59, 999)).toISOString(),
                        })
                    } else {
                        // Establecer inicio y fin del horario encontrado
                        setDateSelected({
                            date_init: new Date(todaySchedule.date_init).toISOString(),
                            date_finish: new Date(todaySchedule.date_finish).toISOString(),
                        })
                    }

                    setReport(todaySchedule.reports)
                    setSelectedSchedule(todaySchedule)
                    // Realizar otras operaciones necesarias con el horario seleccionado
                    updateScheduleTags(todaySchedule)
                } else {
                    console.log('No se encontró ningúna agenda para hoy, limpiar datos')
                    setLoading(false)
                    setLoading(false)
                    setStores([])
                    setSelectedSchedule(null)
                }
            }
        } catch (error) {
            console.error(error)
        }
    }

    const selectDay = async (day) => {
        const selectDate = new Date(day.dateString)
        const endOfDay = selectDate
        endOfDay.setUTCHours(23, 59, 59, 999)

        setDateSelected({
            date_init: new Date(day.dateString).toISOString(),
            date_finish: endOfDay.toISOString(),
        })

        setStores([])
        setPage(0)
        let allSelectedDates = {
            ...vacations,
            [day.dateString]: { selected: true, marked: true, selectedColor: theme.colors.colorPrimary },
        }
        setMarkedDates(allSelectedDates)

        // Llamar a filterDay con selectedDate
        filterDay(selectDate)
    }
    const combineCheckins = (localCheckins, newCheckins) => {
        // Crear un nuevo array para almacenar los checkins combinados
        const combinedCheckins = [...localCheckins]

        newCheckins.forEach((newCheckin) => {
            const existingCheckinIndex = combinedCheckins.findIndex((checkin) => checkin.checkin_id === newCheckin.checkin_id)

            if (existingCheckinIndex !== -1) {
                // Si el checkin ya existe, combinamos las actividades
                combinedCheckins[existingCheckinIndex] = {
                    ...combinedCheckins[existingCheckinIndex],
                    ...newCheckin, // Combina otros campos si es necesario
                    activities: [...combinedCheckins[existingCheckinIndex].activities, ...newCheckin.activities],
                }
            } else {
                // Si el checkin no existe, lo añadimos al array
                combinedCheckins.push(newCheckin)
            }
        })

        return combinedCheckins
    }
    const validateCheckins = async (distributor) => {
        try {
            //consulto si tengo los checkins en mi local
            let checkins = []
            if (distributor && distributor?._id) {
                await schedulesServices.get_checkin(distributor._id, selectedSchedule._id, true).then((response) => {
                    //  console.log('8888888---> response:', response)
                    if (response.length > 0) {
                        checkins = response
                    }
                })

                if (distributor.checkins_data && distributor.checkins_data.length > 0) {
                    // console.log('999999999 ~ checkins_data:', distributor.checkins_data)
                    // Combinar los checkins locales con los nuevos obtenidos
                    checkins = combineCheckins(distributor.checkins_data, checkins)
                }
            }

            // setea los checkins combinados
            setCheckinData(checkins)
            return checkins
        } catch (error) {
            console.error('🚀 ~ validateCheckins ~ error:', error)
        }
    }
    // const validateCheckouts = async (distributor) => {
    //     try {
    //         //consulto si tengo los checkins en mi local
    //         let checkouts = []
    //         if (distributor && distributor?._id) {
    //             await schedulesServices.get_checkout(distributor._id, selectedSchedule._id, true).then((response) => {
    //                 if (response.length > 0) {
    //                     checkouts = response
    //                 }
    //             })

    //             if (distributor.checkins_data && distributor.checkins_data.length > 0) {
    //                 let filter_checo
    //                 // console.log('999999999 ~ checkins_data:', distributor.checkins_data)
    //                 // Combinar los checkins locales con los nuevos obtenidos
    //                 checkins = combineCheckins(distributor.checkins_data, checkins)
    //             }
    //         }

    //         // setea los checkins combinados
    //         setCheckinData(checkins)
    //         return checkins
    //     } catch (error) {
    //         console.error('🚀 ~ validateCheckins ~ error:', error)
    //     }
    // }
    const checkForms = async (schedule, today) => {
        try {
            const {
                form_init,
                form_finish,
                _id,
                distributor,
                activities,
                others_activities,
                activities_advances,
                forms_additionals,
                forms_incidence,
            } = schedule
            // console.log('408 ----- schedule: ', JSON.stringify(schedule))
            // console.log('409 --- schedule.distributor: ', schedule.distributor)

            // console.log('forms_incidence: ', forms_incidence)
            if (form_init && form_finish && _id) {
                const form_id_init = form_init?._id
                const form_id_finish = form_finish?._id
                const formInitStatus = await schedulesServices.getFormStatusFromAdvances(_id, form_id_init, dateSelected)
                //console.log('🚀 .....................~ checkForms ~ formInitStatus:', formInitStatus)
                const formFinishStatus = await schedulesServices.getFormStatusFromAdvances(_id, form_id_finish, dateSelected)
                //console.log('🚀 ~.................... checkForms ~ formFinishStatus:', formFinishStatus)

                let form_to_send = null

                if (!formInitStatus) {
                    //si no hizo matutino
                    form_to_send = {
                        _id: form_id_init,
                        schedule_id: _id,
                        name: '1.1 Matutino',
                        completed: false,
                    }
                    if (campaign.steps && campaign.steps.length > 0) {
                        const step = campaign.steps.find((step) => step.type === CONSTANTS_TYPES_STEPS.BLOCKED_ROUTE)
                        if (step) {
                            const stepDateInit = new Date(step.date_init).toISOString().split('T')[0]
                            const stepDateFinish = new Date(step.date_finish).toISOString().split('T')[0]
                            if (stepDateInit <= today && stepDateFinish >= today && step.forms.some((item) => item._id === form_id_init)) {
                                form_to_send.progressive_mode = true
                            }
                        }
                    }
                    //setForm({ ...form_init, schedule_id: _id })
                } else if (form_finish) {
                    if (!formFinishStatus) {
                        form_to_send = {
                            _id: form_id_finish,
                            schedule_id: _id,
                            name: '1.1 Vespertino',
                            completed: false,
                        }
                        // setForm({ ...form_finish, schedule_id: _id })
                    }
                }
                setForm(form_to_send)
            } else {
                // validar que si no tiene distri,igualmente setee las activities
                if (distributor) {
                    setButtonDistributor(distributor)
                    await validateCheckins(distributor)
                    if (distributor.status == 3 || distributor.status == 4) {
                        setShowSearch(true)
                    }
                }
                // if (distributor && distributor.checkin_id != undefined) {
                //     setCheckinData({
                //         checkin_id: distributor.checkin_id,
                //         activities: [],
                //     })
                // }
                if (forms_incidence && forms_incidence.length > 0) {
                    const getFormIncidence = await schedulesServices.getForm(forms_incidence)
                    setFormIncidence(getFormIncidence)
                }

                if (others_activities) {
                    setListOthesActivities(others_activities ?? [])
                }

                // if (activities) {
                //     setListActivities(activities ?? [])
                // }

                let forms_add = []
                if (forms_additionals && forms_additionals.length) {
                    Promise.all(forms_additionals.map((item) => schedulesServices.getForm(item)))
                        .then((fetchedForms) => {
                            forms_add = fetchedForms // Asigna los formularios obtenidos

                            if (forms_add.length > 0) {
                                setFormsMB(forms_add) // Actualiza el estado con los formularios obtenidos
                            }
                        })
                        .catch((error) => {
                            console.error('Error fetching forms:', error) // Manejo de errores
                        })
                }

                if (activities) {
                    setListActivities(activities ?? [])
                    if (forms_incidence && forms_incidence.length > 0) {
                        const getFormIncidence = await schedulesServices.getForm(forms_incidence)
                        setFormIncidence(getFormIncidence)
                    }
                }
                // handleSetSelectIndexTab()
                renderTabs(distributor, others_activities, forms_add)
            }
        } catch (error) {
            console.error(error)
        }
    }
    const checkinsDistributor = async (option, dataSteps = []) => {
        let checkin_ids = checkinData
        if (checkinData.length == 0) {
            checkin_ids = await validateCheckins(buttonDistributor)
        }

        switch (option) {
            case 'checkin_distributor':
                setButtonDistributor({ ...buttonDistributor, status: 2 })
                checkIn(buttonDistributor._id, selectedSchedule._id, userLat, userLng, dataSteps)
                break
            case 'go_field':
                setButtonDistributor({ ...buttonDistributor, status: 3 })
                checkOut(buttonDistributor._id, selectedSchedule._id, userLat, userLng, checkin_ids[0].checkin_id, [])
                setShowSearch(true)
                break
            case 'return_checkin': // checkin 2 (volver a bodega)
                setButtonDistributor({ ...buttonDistributor, status: 4 })
                checkIn(buttonDistributor._id, selectedSchedule._id, userLat, userLng)
                setShowSearch(true)
                break
            case 'close_day':
                setButtonDistributor({ ...buttonDistributor, status: 5 })
                let checkin_id = checkin_ids.length > 1 ? checkin_ids[1].checkin_id : checkin_ids[0].checkin_id
                checkOut(buttonDistributor._id, selectedSchedule._id, userLat, userLng, checkin_id, [])
                setShowSearch(false)
                break

            default:
                break
        }
    }

    const handleSearchStores = async () => {
        // mostrar esto:
        console.log('handleSearchStores')
        const snapPoints = ['70%']

        openBottomSheet(
            <SearchStores
                selectedSchedule={selectedSchedule}
                initialLocation={initialLocation}
                userLocation={userLocation}
                campaign={campaign}
                onClickGoStore={(store) =>
                    onClickGoStore(
                        store._id,
                        store.forms,
                        selectedSchedule._id,
                        campaign?.steps,
                        store.forms_relevant,
                        store.forms_advances,
                        store.distance,
                    )
                }
            />,
            snapPoints,
        )
    }

    const date = dateSelected.date_finish ? new Date(dateSelected.date_finish) : new Date()

    // console.log('🚀 ~ CampaignList ~ date:', date)
    const dayDate = format(date, 'EEEE d', { locale: es })
    const monthYearDate = format(date, "'de' MMMM yyyy", { locale: es })

    const goToAddStores = () => {
        navigation.navigate('AddStores', { schedule_id: selectedSchedule._id, distributor_id: buttonDistributor._id })
    }

    useEffect(() => {
        // askAgain()
        if (campaign) {
            // let fecha_hoy = new Date()
            // let offset = fecha_hoy.getTimezoneOffset()
            // // Convertir la fecha y hora actual de UTC a la zona horaria local del usuario
            // fecha_hoy.setMinutes(fecha_hoy.getMinutes() - offset)
            // setDayTodayLocal(fecha_hoy)
            filterDay(dateTodayLocal)
        }
        const getLocation = async () => {
            let { status } = await Location.requestForegroundPermissionsAsync()
            if (status !== 'granted') {
                console.error('Permission to access location was denied')
                return
            }

            let location = await Location.getCurrentPositionAsync({})
            const { latitude, longitude } = location.coords
            setUserLocation({ lat: latitude, lng: longitude })

            return { lat: latitude, lng: longitude }
        }

        getLocation()

        if (!userLat || !userLng) {
            console.log('user en ceroooo')
            let user = PostsServices.getUser().then((user) => {
                if (user.lat && user.lng) {
                    setUserLat(user.lat)
                    setUserLng(user.lng)
                    setInitialLocation({ lat: user.lat, lng: user.lng })
                    setUserLocation({ lat: user.lat, lng: user.lng })
                }
            })
        }

        // //
        let location = checkLocation()
        // if (location) {
        //     //   const distanceMoved = distanceInMeters(initialLocation.lat, initialLocation.lng, location.lat, location.lng)
        //     // if (distanceMoved >= 0) {
        //     // setInitialLocation(location)
        //     // }
        // }
    }, [campaign])

    useEffect(() => {
        if (userLocation.lat !== null && userLocation.lng !== null && dateSelected?.date_init != null && selectedSchedule) {
            //setLoading(true)
            getStores()
                .finally(() => {
                    setLoading(false)
                })
                .catch((error) => console.error(error))
        }
        try {
            if (!dateSelected || !dateSelected.date_init) {
                return
            } else {
                const dateInit = dateSelected.date_init
                const todayLocalDate = dateTodayLocal.toISOString().split('T')[0]

                // Verificar si dateInit es una cadena antes de usar split
                if (typeof dateInit === 'string' && dateInit.split('T')[0] !== todayLocalDate) {
                    setShowAlert(true)
                } else {
                    setShowAlert(false)
                }
            }
        } catch (error) {
            console.log('🚀 ~ useEffect ~ error:', error)
        }
    }, [dateSelected, tagID, page])

    const handleTouchActivity = (listActivities: ActivityInput[], activityId: string, typeActivity: string) => {
        const activity = listActivities.find((activity) => activity._id === activityId)

        if (!activity) {
            return
        }
        openBottomSheet(
            <InputCommentActivity
                answer={''}
                handleTextChange={handleTextChange}
                numeric={false}
                title={activity.title}
                activity={activity}
                typeActivity={typeActivity}
            />,
            undefined,
        )
    }

    const handleTextChange = async (text: string, type_activity: string, activityId: string, activity: ActivityInput) => {
        if (text.trim() !== '') {
            const session = await fetchAuthSession()
            const authToken = session.tokens?.accessToken?.toString() || ""

            const hasConnection = await validateConnectionNetwork()
            if (type_activity == 'others') {
                await schedulesServices.updateScheduleActivities(selectedSchedule._id, activityId, text) // se guardan en la nueva tabla de actividades

                if (hasConnection) {
                    const data = {
                        authToken: authToken,
                        schedule_id: selectedSchedule._id,
                        activities: JSON.stringify([{ activity_id: activityId, message: text, title: activity.title }]),
                    }
                    let send = await request_save_schedules_activities(data)
                    console.log('🚀 ~ handleTextChange ~ send:', send)
                } else {
                    const data = {
                        schedule_id: selectedSchedule._id,
                        activities: JSON.stringify([{ activity_id: activityId, message: text, title: activity.title }]),
                    }
                    const response = await schedulesServices.createActivityDistributorPending(data)
                    console.log('111🚀 ~ handleTextChange ~ response:', response)
                }

                updateActivities(setListOthesActivities, activityId)
            } else {
                if (hasConnection && checkinData.length > 0) {
                    const data = {
                        authToken: authToken,
                        schedule_id: selectedSchedule._id,
                        checkin_id: checkinData[0].checkin_id,
                        activities: JSON.stringify([{ activity_id: activityId, message: text, title: activity.title }]),
                    }
                    let send = await request_save_schedules_activities(data)
                    console.log('🚀 ~ handleTextChange ~ send:', send)
                } else {
                    const data = {
                        schedule_id: selectedSchedule._id,
                        checkin_id: checkinData[0].checkin_id,
                        activities: JSON.stringify([{ activity_id: activityId, message: text, title: activity.title }]),
                    }
                    const response = await schedulesServices.createActivityDistributorPending(data)
                    console.log('222🚀 ~ handleTextChange ~ response:', response)
                }

                // setCheckinData({
                //     checkin_id: checkinData.checkin_id,
                //     activities: checkinData.activities,
                // })

                updateActivities(setListActivities, activityId)
            }
        }

        closeBottomSheet(true)
    }

    const updateActivities = (setActivities: React.Dispatch<React.SetStateAction<ActivityInput[]>>, activityId: string) => {
        // console.log('763--- entro al updateActivities')
        setActivities((prevActivities) =>
            prevActivities.map((activity) => {
                if (activity._id === activityId) {
                    if (activity.status === 1) {
                        return { ...activity, status: 3 }
                    } else if (activity.status === 3) {
                        // No hago nada si el status ya es 3
                    }
                }
                return activity
            }),
        )
    }

    const [showOthersActivities, setOthersShowActivities] = useState(false)
    const tabStore = useTabStore()
    const selectTabStore = useNavigateTabsStore()
    const [selectedIndexTabs, setSelectedIndexTabs] = useState(selectTabStore.indexTab ?? -1)
    const [selectedForm, setSelectedForm] = useState(null) // Estado para controlar si hay un formulario seleccionado en MB
    const [formContent, setContents] = useState([])
    const [reloadHideShowData, setReloadHideShowData] = useState(false)
    // console.log('🚀 ~ CampaignList ~ selectedForm:', selectedForm)
    const [showSearch, setShowSearch] = useState(null)
    const actionButonSend = (form_name) => {
        refreshForm()
        setSelectedForm(null)

        if (form_name) {
            openBottomSheet(<FinishSheet closeBottomSheet={closeBottomSheet} title={form_name ?? ''} />)
        }
    }

    const selectForm = (form) => {
        setSelectedForm(form)
        // setContents(form.contents)
        openBottomSheet(
            <FormView
                key={form?._id}
                formContent={form.contents}
                hideOrShow={hideOrShow}
                form_id={form?._id}
                schedule_id={selectedSchedule?._id}
                repeat={form.repeat}
                progress={form.progress}
                totalScore={form.totalScore}
                clearRegisterDatabaseLocal={null}
                hasFinishSheet={true}
                reloadHideShowData={null}
                tags={[]}
                onClickTag={() => {}}
                formType={form.type_form.type}
                actionButonSend={() => actionButonSend(form.name_form)}
                title={form.name_form ?? ''}
                formTypeObj={form.type_form}
            />,
            null,
        )
    }
    const hideOrShow = (hide?: string[], show?: string[], data?: FormContentsModel[]) => {
        // console.log('Debería ocultar estos', hide)
        // console.log('Debería mostrar estos', show)

        let dataMap = data && data.length > 0 ? data : formContent

        const updatedFormContent = dataMap.map((question) => {
            if (hide && hide.includes(question._id)) {
                return {
                    ...question,
                    hideQuestion: true,
                }
            }
            if (show && show.includes(question._id)) {
                return {
                    ...question,
                    hideQuestion: false,
                }
            }
            return question
        })

        setContents(updatedFormContent)

        setReloadHideShowData(!reloadHideShowData)
    }
    // Función para renderizar el contenido depende los tags
    // console.log('BUTTON DISTRIBUTOR', buttonDistributor)
    const renderContent = (tabIndex) => {
        // console.log("866 -- 🚀 ~ renderContent ~ tabIndex:", tabIndex)
        if (Object.keys(report).length !== 0) {
            return (
                <View>
                    <CampaignViewDistributor
                        campaignValues={campaign.values}
                        campaignProgress={campaign.total_progress}
                        date={''}
                        finishDate={campaign.date_finish}
                        form={form}
                        steps={campaign.steps}
                        schedule_id={selectedSchedule?._id}
                        schedule={selectedSchedule}
                        showAlert={showAlert}
                        selectedDate={dateSelected}
                        selectDay={selectDay}
                        scheduleFree={campaign.schedule_free ?? false}
                        generator={generator}
                        buttonDistributor={buttonDistributor}
                        activities={listActivities}
                        checkinsDistributor={checkinsDistributor}
                        handleNotifyIncident={handleNotifyIncident}
                        reportStatus={report?.status}
                        showMapButton={showMapButton}
                    />

                    {report.status == 1 && (
                        <>
                            <Image style={[styles.image, { alignSelf: 'center' }]} source={require('../../../assets/reportIncident.png')} />
                            <Text style={styles.title}>Incidencia: {report.activity}</Text>
                            <Text style={styles.description}>
                                Al reportar una incidencia, el resto del día quedará inhabilitado para realizar actividades. No será posible continuar
                                con las tareas programadas, ya que el sistema bloquea la agenda. Mañana será un nuevo día para retomar las actividades
                                pendientes.
                            </Text>
                        </>
                    )}
                </View>
            )
        } else {
            switch (tabIndex) {
                case 1: // BODEGA
                    return (
                        <View>
                            {campaign && (
                                <CampaignViewDistributor
                                    campaignValues={campaign.values}
                                    campaignProgress={campaign.total_progress}
                                    date={''}
                                    finishDate={campaign.date_finish}
                                    form={form}
                                    steps={campaign.steps}
                                    schedule_id={selectedSchedule?._id}
                                    schedule={selectedSchedule}
                                    showAlert={showAlert}
                                    selectedDate={dateSelected}
                                    selectDay={selectDay}
                                    scheduleFree={campaign.schedule_free ?? false}
                                    generator={generator}
                                    buttonDistributor={buttonDistributor}
                                    activities={listActivities}
                                    checkinsDistributor={checkinsDistributor}
                                    handleNotifyIncident={handleNotifyIncident}
                                    tabSelected={tabIndex}
                                />
                            )}
                            {campaign && buttonDistributor && buttonDistributor?.status == 1 ? (
                                <View style={styles.containerNoProductsBis}>
                                    <Image style={styles.image} source={require('../../../assets/routeView.png')} />
                                    <Text style={styles.title}>Debes realizar Check-in para iniciar tus actividades</Text>
                                    <Text style={styles.description}>
                                        Podrás iniciar tu salida a campo y acceder a las actividades planificadas para el día.
                                    </Text>
                                </View>
                            ) : (
                                listActivities &&
                                listActivities.length > 0 && (
                                    <View
                                        style={[styles.container, { opacity: buttonDistributor?.status === 1 ? 0.5 : 1 }]}
                                        pointerEvents={buttonDistributor?.status === 1 ? 'none' : 'auto'}
                                    >
                                        {/* <ActivityList activities={listActivities} onCheckActivity={handleCheckActivity} type_activity={'distributor'} /> */}
                                        <ActivityList
                                            activities={listActivities}
                                            // onCheckActivity={handleCheckActivity}
                                            type_activity={'distributor'}
                                            handleTouchActivity={handleTouchActivity}
                                        />
                                    </View>
                                )
                            )}
                        </View>
                    )
                case 2: // CAMPO
                    return (
                        <>
                            {buttonDistributor?.status === 2 ? (
                                <View
                                    style={{
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        backgroundColor: theme.colors.filtersBackground,
                                        borderRadius: 8,
                                        padding: 12,
                                        margin: 12,
                                    }}
                                >
                                    <Ionicons name={'warning-outline'} size={24} color={theme.colors.error} style={{ marginRight: 12 }} />
                                    <Text style={styles.textClose}>
                                        Para activar esta solapa y comenzar con tus visitas, debes dirigirte a BODEGA y darle clic al botón “salir de
                                        bodega"
                                    </Text>
                                </View>
                            ) : (
                                <>
                                    <CampaignViewDistributor
                                        campaignValues={campaign.values}
                                        campaignProgress={campaign.total_progress}
                                        date={''}
                                        finishDate={campaign.date_finish}
                                        form={form}
                                        steps={campaign.steps}
                                        schedule_id={selectedSchedule?._id}
                                        schedule={selectedSchedule}
                                        showAlert={showAlert}
                                        selectedDate={dateSelected}
                                        selectDay={selectDay}
                                        scheduleFree={campaign.schedule_free ?? false}
                                        generator={generator}
                                        buttonDistributor={buttonDistributor}
                                        activities={listActivities}
                                        checkinsDistributor={checkinsDistributor}
                                        handleNotifyIncident={handleNotifyIncident}
                                        tabSelected={tabIndex}
                                    />
                                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', marginBottom: 8 }}>
                                        <TouchableOpacity
                                            onPress={() => goToAddStores()}
                                            style={{
                                                flex: 1,
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                backgroundColor: 'white',
                                                borderColor: theme.colors.colorPrimary,
                                                borderWidth: 1.0,
                                                borderRadius: 90,
                                                paddingVertical: 8,
                                                marginHorizontal: 12,
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <Text style={[styles.mainButtonText, { color: theme.colors.colorPrimary }]}>Crear tienda</Text>
                                            <Feather
                                                name='plus'
                                                size={20}
                                                color={theme.colors.colorPrimary}
                                                style={[styles.marginLeft, styles.marginRightBis]}
                                            />
                                        </TouchableOpacity>
                                        {/*<TouchableOpacity
                                            onPress={() => setSelectedIndexTabs(1)}
                                            style={{
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                backgroundColor: 'white',
                                                borderColor: theme.colors.colorPrimary,
                                                borderWidth: 1.0,
                                                borderRadius: 90,
                                                paddingVertical: 8,
                                                marginLeft: 12,
                                            }}
                                        >
                                            <Text style={[styles.mainButtonText, { color: theme.colors.colorPrimary }]}>Volver a bodega</Text>
                                            <Ionicons
                                                name='archive-outline'
                                                size={20}
                                                color={theme.colors.colorPrimary}
                                                style={[styles.marginLeft, styles.marginRightBis]}
                                            />
                                        </TouchableOpacity>*/}
                                    </View>

                                    {loadingSchedule ? <Loader /> : <></>}

                                    <StoresList
                                        stores={stores ?? []}
                                        date={selectedSchedule?.date_init}
                                        tags={selectedSchedule?.tags ?? []}
                                        onClickGoStore={(store) =>
                                            onClickGoStore(
                                                store._id,
                                                store.forms,
                                                selectedSchedule._id,
                                                campaign?.steps,
                                                store.forms_relevant,
                                                store.forms_advances,
                                                store.distance,
                                            )
                                        }
                                        onEndReached={() => handleEndReachedStores()}
                                        selectedTag={(id) => handleSelectLabel(id)}
                                        loading={loading}
                                        route={selectedSchedule?.additional?.route}
                                        showNoStores={buttonDistributor ? false : showNoStores}
                                    />
                                </>
                            )}
                        </>
                    )
                case 3: // ACTIV.
                    return (
                        <>
                            {listOthesActivities.length == 0 ? (
                                <View
                                    style={{
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        backgroundColor: theme.colors.filtersBackground,
                                        borderRadius: 8,
                                        padding: 12,
                                        margin: 12,
                                    }}
                                >
                                    <Ionicons name={'warning-outline'} size={24} color={theme.colors.error} style={{ marginRight: 12 }} />
                                    <Text style={styles.textClose}>No tienes actividades asignadas para el día de la fecha.</Text>
                                </View>
                            ) : (
                                <>
                                    {listOthesActivities && listOthesActivities.length > 0 && (
                                        <ActivityList
                                            activities={listOthesActivities}
                                            // onCheckActivity={handleCheckActivity}
                                            type_activity={'others'}
                                            handleTouchActivity={handleTouchActivity}
                                        />
                                    )}
                                </>
                            )}
                        </>
                    )

                case 4: // MB - PITCH
                    return (
                        <>
                            {/* Vista principal: lista de formularios */}
                            <View>
                                {/* Renderizar los botones de formularios si hay formularios disponibles */}
                                {formsMB.length > 0 ? (
                                    formsMB.map((form, index) => (
                                        <View key={index} style={styles.container}>
                                            <TouchableOpacity
                                                onPress={() => selectForm(form)} // Seleccionar el formulario al hacer clic
                                                style={{
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: 'white',
                                                    borderColor: theme.colors.colorPrimary,
                                                    borderWidth: 1.0,
                                                    borderRadius: 10,
                                                    paddingVertical: 8,
                                                    marginHorizontal: 12,
                                                    marginTop: 10,
                                                }}
                                            >
                                                <Text style={[styles.mainButtonText, { color: theme.colors.colorPrimary }]}>
                                                    {form?.name_form ?? ''}
                                                </Text>
                                            </TouchableOpacity>
                                        </View>
                                    ))
                                ) : (
                                    <>
                                        <View
                                            style={{
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                backgroundColor: theme.colors.filtersBackground,
                                                borderRadius: 8,
                                                padding: 12,
                                                margin: 12,
                                            }}
                                        >
                                            <Ionicons name={'warning-outline'} size={24} color={theme.colors.error} style={{ marginRight: 12 }} />
                                            <Text style={styles.textClose}>No tienes marchas blancas asignadas para el día de la fecha.</Text>
                                        </View>
                                    </>
                                )}
                            </View>

                            {/* Mostrar "Últimos realizados" solo cuando no hay un formulario seleccionado */}
                            {historyForms && historyForms.length > 0 && (
                                <View style={[styles.container, { paddingTop: 24, paddingBottom: 12 }]}>
                                    <Text style={[styles.section, styles.marginHorizontal]}>Últimos realizados</Text>
                                    <HistoryList data={historyForms} />
                                </View>
                            )}
                        </>
                    )
                case -1:
                    return <Loader></Loader>

                default:
                    return <Loader></Loader>
            }
        }
    }

    const renderTabs = (buttonDistributor, listOthesActivities, formsMB) => {
        let newTags = tagsDisData.filter((tag) => {
            if (buttonDistributor == null && (tag.name === 'BODEGA' || tag.name === 'CAMPO')) {
                return false
            }

            if (formsMB && formsMB.length === 0 && tag.name === 'M.B.') {
                return false
            }

            if (listOthesActivities && listOthesActivities.length === 0 && tag.name === 'ACTIV.') {
                return false
            }

            return true
        })

        tabStore.setTagsDis(newTags)
        if (selectedIndexTabs === -1) {
            handleSetSelectIndexTab(newTags[0]['index'])
        }
    }

    const getFreqLabel = (freq: string) => {
        let label = ''
        switch (freq) {
            case 'month':
                label = 'M'
                break
            case 'fortnight':
                label = 'Q'
                break
            case 'weekly':
                label = 'S'
                break
            case 'day':
                label = 'D'
                break
            default:
                label = 'D'
        }
        return label
    }

    const ActivityList = ({ activities, type_activity, handleTouchActivity }) => (
        <FlatList
            data={activities}
            keyExtractor={(item) => item._id}
            renderItem={({ item }) => (
                <View style={styles.container}>
                    <View
                        style={[
                            styles.cardStore,
                            styles.marginHorizontal,
                            styles.spaceBetween,
                            { backgroundColor: item.status === 3 ? theme.colors.formsBackground : 'white' },
                        ]}
                    >
                        <TouchableOpacity
                            style={[styles.buttonCheck, { justifyContent: 'space-between' }]}
                            // onPress={() => onCheckActivity(item._id, type_activity)} // listActivities, activityId
                            onPress={() => handleTouchActivity(activities, item._id, type_activity)}
                        >
                            <View style={{ maxWidth: '75%' }}>
                                <Text
                                    style={[
                                        styles.textNameStore,
                                        {
                                            color: item.status === 3 ? theme.colors.darkGray : theme.colors.textPrimary,
                                            //textDecorationLine: item.status === 3 ? 'line-through' : 'none',
                                        },
                                    ]}
                                    numberOfLines={2}
                                    ellipsizeMode='tail'
                                >
                                    {item.title ?? ''}
                                </Text>
                            </View>
                            <View style={styles.containerRow}>
                                <View
                                    style={[
                                        styles.label,
                                        {
                                            backgroundColor: item.status === 3 ? theme.colors.darkGray : theme.colors.colorSecondary,
                                            marginRight: 12,
                                            maxWidth: 45,
                                        },
                                    ]}
                                >
                                    <Ionicons name={'calendar'} size={12} color={'white'} style={styles.paddingRight} />
                                    <Text style={styles.frequency}>{getFreqLabel(item.frequency)}</Text>
                                </View>
                                <Ionicons
                                    name={item.status === 3 ? 'checkbox' : 'square-outline'}
                                    size={24}
                                    color={item.status === 3 ? theme.colors.colorPrimary : theme.colors.textPrimary}
                                />
                            </View>
                        </TouchableOpacity>
                    </View>
                </View>
            )}
        />
    )
    const HistoryList = ({ data }) => (
        <FlatList
            data={data}
            keyExtractor={(item, index) => item._id + index}
            renderItem={({ item }) => (
                <View style={styles.container}>
                    <View style={[styles.cardStore, styles.marginHorizontal, { backgroundColor: theme.colors.formsBackground }]}>
                        <View style={[styles.buttonCheck, { justifyContent: 'flex-start', marginBottom: 12 }]}>
                            <Image style={styles.asset} source={require('../../../assets/marchaBlanca.png')} />
                            <View style={{ flex: 5, marginRight: 12 }}>
                                <Text style={styles.textMA} numberOfLines={2} ellipsizeMode='tail'>
                                    {item.title ?? ''}
                                </Text>
                                <Text style={styles.textDistanceStore} numberOfLines={2} ellipsizeMode='tail'>
                                    {parseDateCardHistory(item.date) ?? ''}
                                </Text>
                            </View>
                        </View>
                        {item.questions &&
                            item.questions.length > 0 &&
                            item.questions.map((question, index) => (
                                <View key={index.toString()}>
                                    <View style={{ flex: 1, marginHorizontal: 6 }} key={question._id}>
                                        <Text style={styles.textQuestion}>{question.question} </Text>
                                        <Text style={styles.textAnswer}>
                                            {question.questionInput != '' ? question.questionInput : question.questionOptionSelectedText[0]}
                                        </Text>
                                    </View>
                                </View>
                            ))}
                    </View>
                </View>
            )}
        />
    )

    const handleNotifyIncident = (name) => {
        if (formIncidence) {
            openBottomSheet(
                <View style={{ flex: 1 }}>
                    <Image style={[styles.image, { alignSelf: 'center' }]} source={require('../../../assets/reportIncident.png')} />
                    <View style={[styles.containerRow, { flex: 1, alignSelf: 'center', marginVertical: 8 }]}>
                        <Ionicons name='map-outline' size={24} color={'black'} style={{ marginRight: 4 }} />
                        <Text
                            style={{
                                fontSize: 18,
                                fontWeight: 'bold',
                                color: theme.colors.textPrimary,
                                textAlign: 'center',
                                alignSelf: 'center',
                            }}
                        >
                            {name}
                        </Text>
                    </View>
                    <FormView
                        key={formIncidence?._id}
                        formContent={formIncidence?.contents}
                        hideOrShow={hideOrShow}
                        form_id={formIncidence?._id}
                        schedule_id={selectedSchedule?._id}
                        repeat={formIncidence?.repeat}
                        progress={formIncidence?.progress}
                        totalScore={formIncidence?.totalScore}
                        clearRegisterDatabaseLocal={null}
                        hasFinishSheet={false}
                        reloadHideShowData={null}
                        tags={[]}
                        onClickTag={() => {}}
                        formType={formIncidence?.type_form.type}
                        actionButonSend={async () => await actionButonSendIncidence()}
                        formTypeObj={formIncidence.type_form}
                    />
                    <TouchableOpacity style={[styles.borderButton, { marginTop: -16, marginBottom: 24 }]} onPress={() => closeBottomSheet(true)}>
                        <Text style={styles.borderButtonText}>Cancelar</Text>
                    </TouchableOpacity>
                </View>,
            )
        }
    }

    const actionButonSendIncidence = async () => {
        try {
            const res = await schedulesServices.updateScheduleReport(selectedSchedule._id, true)
            setReport({ status: 1 })
            // tabStore.setIndexTab(1)
            closeBottomSheet(true)
        } catch (error) {
            console.error('🚀 ~ actionButonSendIncidence ~ error', error)
        }
    }

    const handleSetSelectIndexTab = (index: number) => {
        setSelectedIndexTabs(index)
        selectTabStore.setIndexTab(index)
    }

    const fechaActual = new Date()
    // const today = new Date('2024-10-05T12:56:46.950Z')
    const fechaArgentina = new Date(fechaActual.setHours(fechaActual.getHours() - 3))

    const fechaCompleta = formatearFechaArgentina(fechaArgentina)

    const [diaMes, resto, año] = fechaCompleta.split(' de ')

    const primeraParte = diaMes

    const segundaParte = ` de ${resto} ${año}`

    return (
        <View style={styles.container}>
            <LinearGradient
                colors={[theme.colors.linearGradientStart, theme.colors.linearGradientEnd]}
                style={{ flex: 1 }}
                start={{ x: 0, y: 0.5 }}
                end={{ x: 1, y: 0.5 }}
            >
                <View style={[styles.containerRow, styles.marginHorizontal, styles.spaceBetween]}>
                    <View style={[styles.containerRow, { marginTop: 4 }]}>
                        <Text style={[styles.date, { fontWeight: 'bold', color: 'white' }]}>{primeraParte}</Text>
                        <Text style={[styles.date, { color: 'white' }]}>{segundaParte.toLowerCase()}</Text>
                    </View>
                    <View style={styles.flexDirectionRowBis}>
                        {showSearch && (
                            <TouchableOpacity style={styles.iconButton} onPress={() => handleSearchStores()}>
                                <Feather name='search' size={20} color={'white'} />
                            </TouchableOpacity>
                        )}

                        <TouchableOpacity style={styles.iconButton} onPress={() => checkLocation()}>
                            <Feather name='refresh-ccw' size={20} color={'white'} />
                        </TouchableOpacity>
                    </View>
                    {/*<Ionicons name={'calendar-outline'} size={20} color={theme.colors.textPrimary} style={styles.paddingRight} />*/}
                </View>
                {!buttonDistributor && selectedSchedule?.vacation == false && (
                    <View>
                        <TouchableOpacity onPress={() => handleNotifyIncident('')}>
                            <Text style={[styles.floatingButtonText, { marginTop: 12 }]}>Notificar incidencia</Text>
                        </TouchableOpacity>
                        <View style={[styles.dividerHorizontalLine, { marginTop: 12 }]}></View>
                    </View>
                )}
            </LinearGradient>

            <TagsActivities
                status={buttonDistributor ? buttonDistributor.status : -1}
                // tabs={tabStore.tagsDis}
                selectedIndexTabs={selectedIndexTabs}
                setSelectedIndexTabs={handleSetSelectIndexTab}
                renderContent={renderContent}
                fechaCompleta={fechaCompleta}
                report={report}
                schedule={selectedSchedule}
            />

            {showCalendar && (
                <Calendar
                    onDayPress={(day) => {
                        setShowCalendar(false)
                        selectDay(day)
                    }} //selectDay
                    markedDates={markedDates}
                    theme={{
                        backgroundColor: 'white',
                        calendarBackground: 'white',
                        textSectionTitleColor: theme.colors.textPrimary,
                        selectedDayBackgroundColor: theme.colors.colorPrimary,
                        selectedDayTextColor: 'white',
                        todayTextColor: theme.colors.textSecondary,
                        todayBackgroundColor: theme.colors.disabled,
                        todayDotColor: 'white',
                        dayTextColor: theme.colors.textPrimary,
                        textDisabledColor: theme.colors.mediumGray,
                        arrowColor: theme.colors.colorPrimary,
                    }}
                    style={{
                        marginHorizontal: 12,
                    }}
                    current={new Date().toISOString()}
                />
            )}

            {selectedSchedule ? (
                <>
                    <View
                        style={(form && !form.completed && form.progressive_mode) || showAlert ? styles.blockedView : null}
                        pointerEvents={(form && !form.completed && form.progressive_mode) || showAlert ? 'none' : null}
                    >
                        {/* <StoresList
                                stores={stores ?? []}
                                date={selectedSchedule?.date_init}
                                tags={selectedSchedule?.tags ?? []}
                                onClickGoStore={(store) =>
                                    onClickGoStore(
                                        store._id,
                                        store.forms,
                                        selectedSchedule._id,
                                        campaign?.steps,
                                        store.forms_relevant,
                                        store.forms_advances,
                                        store.distance,
                                    )
                                }
                                onEndReached={() => handleEndReachedStores()}
                                selectedTag={(id) => handleSelectLabel(id)}
                                loading={loading}
                                route={selectedSchedule?.additional?.route}
                                showNoStores={buttonDistributor ? false : showNoStores}
                            /> */}
                    </View>
                </>
            ) : (
                <>
                    {!loading ? (
                        <View style={styles.containerNoProducts}>
                            <Image style={styles.image} source={require('../../../assets/pendingPlanning.png')} />
                            <Text style={styles.title}>Planificación pendiente</Text>
                            <Text style={styles.description}>
                                Para habilitar esta sección, primero debés completar la planificación mensual y semanal accediendo al ícono del
                                calendario ubicado en el nav. Una vez que la planificación semanal esté lista, esta debe ser aprobada por el gerente.
                                Solo después de recibir esta aprobación, la sección de tiendas se habilitará para su uso.
                            </Text>
                            <TouchableOpacity style={styles.mainButtonRetry} onPress={() => onRefresh(true)}>
                                <Text style={styles.mainButtonTextRetry}>Reintentar</Text>
                            </TouchableOpacity>
                            {/*<View style={styles.buttonContainer}>
                            <TouchableOpacity style={styles.borderButton}>
                                <Text style={styles.borderButtonText}>Ir a calendario</Text>
                            </TouchableOpacity>
                        </View>*/}
                        </View>
                    ) : (
                        <Loader />
                    )}
                </>
            )}
        </View>
    )
}
export const PitchModal = ({ image, title, desc, acceptModal, cancel }) => {
    const [text, setText] = useState('')

    return (
        <View>
            <Text>Pitch de cuenta</Text>
            <Text>{title}</Text>
            <Text>{desc}</Text>
            <TextInput onChangeText={(text) => setText(text)} value={text} placeholder='Ingresa un comentario...' multiline={true} />
            <TouchableOpacity style={styles.mainButton} onPress={() => acceptModal(text)}>
                <Text style={styles.mainButtonText}>Aceptar</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.mainButton} onPress={() => cancel()}>
                <Text style={styles.mainButtonText}>Cancelar</Text>
            </TouchableOpacity>
        </View>
    )
}
export const ScheduleVacationAlert = () => {
    return (
        <>
            <View style={styles.containerOnVacation}>
                <Image style={styles.image} source={require('../../../assets/stores/onVacation.png')} />
                <Text style={styles.title}>¡A disfrutar!</Text>
                <Text style={styles.description}>
                    Estás en período de vacaciones, no podrás visualizar o realizar agendas. Nos vemos a la vuelta ¡buenas vacaciones!
                </Text>
            </View>
        </>
    )
}
interface StoresListProps {
    stores?: StoresListModel[]
    date?: string
    tags?: TagsModel[]
    onClickGoStore?: (store: StoresListModel) => void
    onEndReached?: () => void
    selectedTag?: (id: number) => void
    loading?: boolean
    route?: string
    showNoStores?: boolean
}
export const StoresList = ({ stores, date, tags, onClickGoStore, onEndReached, selectedTag, loading, route, showNoStores }: StoresListProps) => {
    const { languageFile } = getLanguage()

    const filterByTag = (tag: TagsModel) => {
        selectedTag(Number(tag._id))
    }

    return (
        <View style={styles.container}>
            {/* <Text style={[styles.textDate, { paddingHorizontal: 10 }]}>{date}</Text> */}
            <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} style={styles.scrollView}>
                <View style={styles.containerStoresFilter}>
                    <StoresFilterView tags={tags} onClickTag={filterByTag} />
                </View>
            </ScrollView>
            {stores && stores.length > 0 ? (
                <FlatList
                    style={styles.flatList}
                    data={stores}
                    extraData={stores}
                    initialNumToRender={10}
                    // ref={mainViewRef}
                    keyExtractor={(item, index) => index.toString()}
                    horizontal={false}
                    showsVerticalScrollIndicator={false}
                    renderItem={({ item: stores }) => <StoreItem key={stores?._id} store={stores} onClickGoStore={onClickGoStore} route={route} />}
                    numColumns={1}
                    onEndReached={() => onEndReached()}
                    onEndReachedThreshold={1}
                    ListFooterComponent={loading && <Loader />}
                />
            ) : (
                <>
                    {showNoStores && (
                        <View style={styles.containerNoProductsBis}>
                            <Image style={styles.image} source={require('../../../assets/noAgendaToday.png')} />
                            <Text style={styles.title}>{languageFile.no_agenda_for_today}</Text>
                            <Text style={styles.description}>{languageFile.consult_your_supervisor}</Text>
                        </View>
                    )}
                </>
            )}
        </View>
    )
}

export const createTag = (status: number, languageFile) => {
    try {
        switch (status) {
            case CampaignStatus?.STATUS_FORM_PENDING:
                return {
                    title: languageFile?.pending_mayus,
                    image: '',
                    _id: String(CampaignStatus.STATUS_FORM_PENDING),
                    isSelected: false,
                } as TagsModel
            case CampaignStatus?.STATUS_FORM_APPROVED:
                return {
                    title: languageFile?.visited_mayus,
                    image: '',
                    _id: String(CampaignStatus.STATUS_FORM_APPROVED),
                    isSelected: false,
                } as TagsModel
            case CampaignStatus?.STATUS_FORM_PENDING_MODERATION:
                return {
                    title: languageFile?.in_review_mayus,
                    image: '',
                    _id: String(CampaignStatus.STATUS_FORM_PENDING_MODERATION),
                    isSelected: false,
                } as TagsModel
            case CampaignStatus.STATUS_FORM_REFUSED:
                return {
                    title: languageFile?.redo_mayus,
                    image: '',
                    _id: String(CampaignStatus.STATUS_FORM_REFUSED),
                    isSelected: false,
                } as TagsModel

            case CampaignStatus.STATUS_FORM_IN_PROGRESS:
                return {
                    title: languageFile?.in_progress_mayus,
                    image: '',
                    _id: String(CampaignStatus.STATUS_FORM_IN_PROGRESS),
                    isSelected: false,
                } as TagsModel
            case CampaignStatus.STATUS_FORM_PENDING_SYNC:
                return {
                    title: 'SYNC.',
                    image: '',
                    _id: String(CampaignStatus.STATUS_FORM_PENDING_SYNC),
                    isSelected: false,
                } as TagsModel
            default:
                console.log('..........................................No tengo status')
                return null
        }
    } catch (error) {
        console.error(error)
    }
}

// const tagsDis = [
//     {
//         name: 'BODEGA',
//         index: 1,
//     },
//     {
//         name: 'CAMPO',
//         index: 2,
//     },
//     {
//         name: 'ACTIV.',
//         index: 3,
//     },
//     {
//         name: 'M.B.',
//         index: 4,
//     },
// ]
const formsMBhistory = [
    {
        _id: '1',
        title: 'Marchas Blancas',
        questions: [
            { _id: '1', question: 'Nombre del distribuidor:', questionInput: 'Test 3' },
            { _id: '1', question: '¿Le intereso nuestra propuesta?', questionInput: 'NO' },
        ],
        date: new Date().toISOString(),
        icon: 'etc',
    },
    { _id: '2', title: 'Pitch de cuenta', questions: [], date: new Date().toISOString(), icon: 'etc' },
]

export const TagsActivities = ({ status, selectedIndexTabs, setSelectedIndexTabs, renderContent, report, fechaCompleta, schedule }) => {
    const { tagsDis } = useTabStore()

    const isDisabled = (i) => {
        return status == 1 && i == 2
    }

    const [diaMes, resto] = fechaCompleta.split(' de ')

    const getTabTitle = (index: number) => {
        let title = ''
        let description = ''
        let isSaturday = diaMes.includes('Sábado')

        switch (index) {
            case 1:
                return {
                    title: '',
                    description: '',
                }
            case 2:
                return {
                    title: '',
                    description: '',
                }
            case 3:
                if (isSaturday) {
                    return {
                        title: 'Fin de semana productivo',
                        description:
                            'Este día se destina a realizar tareas administrativas internas esenciales para el buen funcionamiento de la organización.',
                    }
                } else {
                    return {
                        title: 'Tus otras actividades',
                        description:
                            'En este apartado podrás visualizar tus actividades mensuales, quincenales y/o diarias. Marca las tareas que tienes planificado realizar durante el día de hoy.',
                    }
                }
            case 4:
                return {
                    title: 'Marcha blanca y pitch de cuentas',
                    description:
                        'Aquí podrás visualizar las marchas blancas y los pitch de cuentas que has realizado durante el día de hoy, con el objetivo de captar potenciales nuevos clientes.',
                }
            default:
                return {
                    title: '',
                    description: '',
                }
        }
    }

    let { title, description } = getTabTitle(selectedIndexTabs)

    return (
        <>
            {schedule && !schedule?.vacation ? (
                <View style={[Object.keys(report).length !== 0 ? { opacity: 0.5, pointerEvents: 'none', marginBottom: 12 } : null]}>
                    {tagsDis && tagsDis.length == 1 ? null : (
                        <LinealTabs
                            tabs={tagsDis}
                            selectedIndex={selectedIndexTabs}
                            color={'white'}
                            colorSelected={'white'}
                            onSelectedTab={(i) => {
                                if (!isDisabled(i)) {
                                    setSelectedIndexTabs(i)
                                }
                            }}
                            gradient={true}
                            status={status}
                        />
                    )}
                    <View>
                        {title != '' && (
                            <View>
                                <Text style={[styles.titleActiv, styles.marginHorizontal, { marginBottom: 4, marginTop: 12 }]}>{title}</Text>
                            </View>
                        )}
                        {description != '' && (
                            <View>
                                <Text style={[styles.descriptionActiv, styles.marginHorizontal, { marginBottom: 12 }]}>{description}</Text>
                            </View>
                        )}
                    </View>
                    {!isDisabled(selectedIndexTabs) ? renderContent(selectedIndexTabs) : null}
                </View>
            ) : (
                <>
                    {schedule && schedule?.vacation && (
                        <View style={[styles.containerVacationAlert, { marginBottom: 12 }]}>
                            <ScheduleVacationAlert />
                        </View>
                    )}
                </>
            )}
        </>
    )
}
